export default __webpack_public_path__ + "static/media/bgWinners.e63fd6c5.png";